// extracted by mini-css-extract-plugin
export default {"appContainer":"Layout_appContainer__+jaz9","mainContainer":"Layout_mainContainer__S2fPj"};